/**
 * Prominent, non-intrusive entry point that opens the activity-scoped AI
 * Coach panel. The activity id is captured here and forwarded through the
 * onClick handler so the parent can render the drawer with the exact
 * activity currently on screen.
 */
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export const ActivityCoachButton = ({ onClick, disabled = false, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-testid="activity-coach-button"
    className={cn(
      "btn-primary-app px-4 py-2.5 text-xs tracking-[0.2em] uppercase",
      className
    )}
  >
    <Sparkles className="w-4 h-4" strokeWidth={1.5} aria-hidden="true" />
    AI Coach
  </button>
);

export default ActivityCoachButton;
